/* eslint-disable formatjs/no-emoji */
import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { intl } from '@trello/i18n';
import { BoardIcon } from '@trello/nachos/icons/board';

import type { BadgeProps } from './types';

// eslint-disable-next-line @trello/less-matches-component
import styles from './PowerUp.less';

export const Badges: FunctionComponent<BadgeProps> = ({
  button,
  usage,
  darkMode,
  staffPick,
  integration,
  hideInstallCues = false,
}) => (
  <div className={styles.badges}>
    {button}
    {!hideInstallCues && typeof usage === 'number' && usage > 0 && (
      <div
        className={styles.pupBadge}
        title={intl.formatMessage(
          {
            id: 'templates.directory_power_up_item.usage-explanation',
            defaultMessage: 'Enabled on more than {count} boards',
            description: 'Explains the board usage',
          },
          { count: usage.toLocaleString() },
        )}
      >
        <BoardIcon dangerous_className={styles.usageBadgeIcon} />
        <span>{usage.toLocaleString()}+</span>
      </div>
    )}
    {integration && (
      <div
        className={classNames(styles.pupBadge, styles.pupIntegrationBadge)}
        title={intl.formatMessage({
          id: 'templates.directory_power_up_item.integration-explanation',
          defaultMessage:
            'This integration will not count towards your Power-Up limit',
          description: 'Explains the integration effects for the power up',
        })}
      >
        <FormattedMessage
          id="templates.directory_power_up_item.integration"
          defaultMessage="🔗 Integration"
          description="Integration"
        />
      </div>
    )}
    {darkMode && (
      <div className={classNames(styles.pupBadge, styles.darkModeBadge)}>
        <FormattedMessage
          id="templates.directory_power_up_item.dark-mode"
          defaultMessage="🌙 Supports dark mode"
          description="Dark Mode"
        />
      </div>
    )}
    {!hideInstallCues && staffPick && (
      <div
        className={classNames(styles.pupBadge, styles.genericBadge)}
        title={intl.formatMessage({
          id: 'templates.directory_power_up_item.staff-pick-explanation',
          defaultMessage: 'A favorite of a Trello employee',
          description: 'Explains the staff pick',
        })}
      >
        <FormattedMessage
          id="templates.directory_power_up_item.staff-pick"
          defaultMessage="❤️ Staff pick"
          description="Staff Pick"
        />
      </div>
    )}
  </div>
);
